import { Fragment, useState, useRef, useEffect, useCallback } from 'react';
import { getAgentUpdatedOwnStatus, getAwayMode } from '../operators/getters';
import { getWasModalDismissedThisSession } from '../operators/statusModalOperators';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AgentStatusPrompt = ({
  agentStatus,
  Prompt,
  children
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const prevAgentStatus = useRef(null);
  useEffect(() => {
    if (prevAgentStatus.current && !getAwayMode(prevAgentStatus.current) && getAwayMode(agentStatus) && !getAgentUpdatedOwnStatus(agentStatus) && !getWasModalDismissedThisSession(agentStatus)) {
      setModalOpen(true);
    }
  }, [agentStatus, setModalOpen]);
  useEffect(() => {
    prevAgentStatus.current = agentStatus;
  }, [agentStatus]);
  const closeModal = useCallback(() => setModalOpen(false), [setModalOpen]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [modalOpen && /*#__PURE__*/_jsx(Prompt, {
      closeModal: closeModal
    }), children]
  });
};
AgentStatusPrompt.displayName = 'AgentStatusPrompt';
export default AgentStatusPrompt;